import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { format } from 'date-fns';
import { ru as localeRu } from 'date-fns/locale';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { Button, Spin } from 'antd';
import { useCities } from '../../api/user-list-api/user-list-api';
import {
    getOrders,
    getSummary,
    useDownloadFile,
    useMakePayment,
} from '../../api/product-report/product-report';
import ProductReportTable from './product-report-table/product-report-table';
import ReportTable from './product-report-table/report-table';
import PaymentModal from '../UI/payment-modal/payment-modal';
import s from './styles.module.css';

registerLocale('ru', localeRu);

const ProductReport = ({ translation, language }) => {
    const { data: citiesData } = useCities();
    const [role, setRole] = useState(null);
    const [page, setPage] = useState(0);
    const [cityId, setCityId] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [paymentModalVisible, setPaymentModalVisible] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState(null);
    const today = new Date();
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    const fromStr = startDate
        ? format(startDate, 'yyyy-MM-dd')
        : format(threeMonthsAgo, 'yyyy-MM-dd');
    const toStr = endDate ? format(endDate, 'yyyy-MM-dd') : format(today, 'yyyy-MM-dd');
    const qp = { cityId, dateFrom: fromStr, dateTo: toStr, plagination: page };
    const {
        data: ordersData,
        isLoading: ordersLoading,
        error: ordersError,
    } = useQuery(['getReportFilial', qp], getOrders, { keepPreviousData: true });
    const {
        data: summaryData,
        isLoading: summaryLoading,
        error: summaryError,
    } = useQuery(['getSummary', qp], getSummary, {
        keepPreviousData: true,
        enabled: role === 'RoleLeadAdmin',
    });
    const makePaymentMutation = useMakePayment();
    const downloadMutation = useDownloadFile();
    useEffect(() => {
        const token = Cookies.get('token');
        if (token) {
            try {
                const d = jwtDecode(token);
                setRole(d.role);
            } catch {
                setRole('');
            }
        }
    }, []);
    const handleCityChange = (e) => {
        setCityId(e.target.value);
        setPage(0);
    };
    const handleDateChange = ([s, e]) => {
        setStartDate(s);
        setEndDate(e);
        setPage(0);
    };
    const handlePageChange = (p) => setPage(p);
    const openPaymentModal = () => setPaymentModalVisible(true);
    const handlePayment = () => {
        if (!paymentAmount) return;
        makePaymentMutation.mutate(
            { cityId, dateFrom: fromStr, dateTo: toStr, amount: paymentAmount },
            {
                onSuccess: () => {
                    setPaymentModalVisible(false);
                    setPaymentAmount(null);
                },
            },
        );
    };
    const handleDownload = () => {
        downloadMutation.mutate(
            { dateFrom: fromStr, dateTo: toStr },
            {
                onSuccess: ({ blob, fileName }) => {
                    const url = URL.createObjectURL(new Blob([blob]));
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                },
            },
        );
    };
    if (ordersLoading || summaryLoading) return <Spin />;
    if (ordersError || summaryError) return <div>Ошибка при загрузке данных</div>;
    return (
        <div className={s.container}>
            <div className={s.content}>
                <div className={s['filter-panel']}>
                    {role === 'RoleLeadAdmin' && (
                        <div className={s['filter-item']}>
                            <label className={s['filter-label']}>Фильтр по городам</label>
                            <select
                                className={s['filter-select']}
                                value={cityId}
                                onChange={handleCityChange}
                            >
                                <option value="">Все города</option>
                                {citiesData?.map((c) => (
                                    <option key={c.id} value={c.id}>
                                        {language === 'ru' ? c.name : c.name_ch}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className={s['filter-item']}>
                        <label className={s['filter-label']}>Поиск по дате</label>
                        <DatePicker
                            selected={startDate}
                            onChange={handleDateChange}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange
                            placeholderText={translation('filterDateBetween')}
                            locale="ru"
                            dateFormat="dd.MM.yyyy"
                            className={s['filter-datepicker']}
                        />
                    </div>
                </div>
                <div className={s['section-title']}>
                    <h1 className={s['title-text']}>Расчёт по доставке</h1>
                    {role === 'RoleLeadAdmin' && cityId && (
                        <Button
                            style={{ backgroundColor: '#100e71' }}
                            type="primary"
                            onClick={openPaymentModal}
                        >
                            Оплатить филиалу
                        </Button>
                    )}
                    {role === 'RoleLeadAdmin' && (
                        <Button
                            style={{ backgroundColor: '#100e71' }}
                            type="primary"
                            loading={downloadMutation.isLoading}
                            onClick={handleDownload}
                        >
                            Скачать excel файл
                        </Button>
                    )}
                </div>
                <div className={s['order-div']}>
                    <ProductReportTable
                        translation={translation}
                        language={language}
                        page={page}
                        setPage={handlePageChange}
                        tableOrder={ordersData}
                        role={role}
                    />
                </div>
                <div className={s['section-title']}>
                    <h1 className={s['title-text']}>Прибыль</h1>
                </div>
                {role === 'RoleLeadAdmin' && (
                    <div className={s['order-div']}>
                        <ReportTable
                            translation={translation}
                            language={language}
                            page={page}
                            setPage={handlePageChange}
                            tableOrder={summaryData}
                            role={role}
                        />
                    </div>
                )}
            </div>
            <PaymentModal
                visible={paymentModalVisible}
                amount={paymentAmount}
                setAmount={setPaymentAmount}
                onOk={handlePayment}
                onCancel={() => setPaymentModalVisible(false)}
                confirmLoading={makePaymentMutation.isLoading}
            />
        </div>
    );
};

export default ProductReport;
